import Pricing5 from './Pricing5'
export default Pricing5
